<template>
  <div>
    <table class="main-table w-100 text-right">
      <tr class="text-break">
        <td class="pl-4 text-left text-middle-bond" style="width: 45%">
          TX HASH
        </td>
        <td class="text-left text-middle-bond" style="width: 37%">
          DETAILS
        </td>
        <td class="text-left text-middle-bond" style="width: 18%">
          VALUE
        </td>

      </tr>
      <tr v-for="(item,index) in data" :key="index" class="hover-bg tableBlock">
        <td class="mb-none text-left d-flex flex-row align-items-center">
          <div class="ml-4 trans-icon">
            <div class="trans-icon-img"></div>
          </div>
          <div class="block-rights ml-3">
            <router-link :to="`/tx/${item.txHash}`">
              <span class="fontsize-13" style="cursor: pointer">{{getSortAddress(item.txHash)}}</span>
            </router-link>
            <span>{{updateTimestamp(item.timestamp)}}</span>
          </div>
        </td>
        <td class="text-left">
          <div class="block-rights">
            <span class="trans-detail-text fontsize-13">
              From :
              <span>
<!--               <router-link :to="{ name:'address',params:{number:item.from} }">-->
               <router-link class="fontsize-13" :to="`/address/${item.from}`">
                  {{getSortAddress(item.from)}}<br>
               </router-link>
                </span>
              TO <span style="opacity: 0.8">
                 <span class="trans-td-text" v-if="item.isContract == 1">
              <router-link class="fontsize-13" v-if="item.contract && item.symbol" :to="`/address/${item.contract}`">
                {{item.symbol}}
              </router-link>
              <router-link class="fontsize-13" v-else :to="`/address/${item.contract}`">
                {{getSortAddress(item.contract)}}
              </router-link>
              <router-link class="fontsize-13" v-if="item.to && item.symbol" :to="`/address/${item.to}`">
                {{item.symbol}}
              </router-link>
              <router-link class="fontsize-13" v-else :to="`/address/${item.to}`">
                {{getSortAddress(item.to)}}
              </router-link>
            </span>
            <span class="trans-td-text" v-else>
              <router-link class="fontsize-13" v-if="item.contract" :to="`/address/${item.contract}`">
                {{getSortAddress(item.contract)}}
              </router-link>
              <router-link class="fontsize-13" v-else :to="`/address/${item.to}`">
                {{getSortAddress(item.to)}}
              </router-link>
            </span>
                </span>
            </span>
          </div>
        </td>
        <td class="text-left">
          <div class="text-middle-bond fontsize-13">
            {{parseValue(item.value)}} MAPO
          </div>
        </td>
      </tr>
    </table>

<!--    <paginationSp :config="cfg_pagination" @reloadList="getList()" class="py-3"/>-->
  </div>
</template>

<script>
import { updateAge,getSortAddress,parseBalance } from '@/util/index'
// import paginationSp from '@/views/_comp/pagination_sp.vue'

export default {
  name: 'tableTransactions',
  components: {
    // paginationSp,
  },
  props: [
    'data',
    'cfg',
  ],
  data() {
    return {
      showImg:0,
      cfg_pagination: {
        'page_size': 10, //每页条目数量
        'page_current': 1, // 当前页
        'count_items': 0, //总个数，和总页数选填其一
        'btn_num': 5, // 按钮个数
        'turnpage_top': true, // 翻页时操作滚动置顶
        'count_pages':0, //总页数，和个页数选填其一 // 默认请给 0 值-便于首次加载时不露出分页器
      },
      data_onshow: [
        {}
      ],

      contract:'',
      bykey:'',
      pairlist:''
    }
  },
  computed: {},
  watch: {},
  methods: {
    //转换Value
    parseValue (input) {
      if (!input){
        return '0'
      }
      const { i, d } = parseBalance(input)
      if (i === '0' && d.slice(1, 4) === '000') {
        if (d === ',000,000,000,000,000,000') {
          return '0'
        } else {
          return '< 0.001'
        }
      }
      return `${i}.${d.slice(1, 4)}`
    },
    //age转换
    updateTimestamp(val) {
      return updateAge(val)
    },

    //地址转换
    getSortAddress(val) {
      return getSortAddress(val)
    },

    //跳转Transaction
    goTransaction(item) {
      var txhash= item.txhash
      this.$router.push(
          {
            path:"/transaction",
            query:{txhash:txhash}
          }
      )
    },
    //跳转token
    goToken(item) {
      var contract= item.contract
      this.$router.push(
          {
            path:"/token",
            query:{contract:contract}
          }
      )
    },
    //跳转地址
    goAddress(item) {
      var address= item.address
      this.$router.push(
          {
            path:"/address",
            query:{address:address}
          }
      )
    },
    initData(){
      let v = this
      // console.log(11111,2222)
      // v.api('url',{},{vue:v}).then(function (){})

      if(!v.data)return

      v.cfg_pagination.page_current = 1

      // 计算页码
      v.cfg_pagination.count_pages = Math.ceil(v.data.length/v.cfg_pagination.page_size)

      // 过滤数据
      v.getList()
    },

    getList(){
      //判断DGT在最前
      var obj={};
      var tokenname='DGT'
      for (var i=0 ; i<this.data.length;i++) {
        // console.log(v.data_onshow[i].token0symbol)
        // console.log(tokenname,11111)
        if (this.data[i].token0symbol ==  tokenname){
          obj=this.data[i]
          // console.log(this.obj,3333)
          this.data.splice(i,1);
          this.data.unshift(obj)
        }
      }
      let v = this
      // 过滤条目
      let start = (v.cfg_pagination.page_current -1) * v.cfg_pagination.page_size
      let end = v.cfg_pagination.page_current * v.cfg_pagination.page_size
      v.data_onshow = v.data.slice(start, end)

      //判断liquidity排序
      for (const item of v.data_onshow) {
        // console.log(item,4444);
        // console.log(item.token0symbol,33333)
        if (item.token0symbol=='TRUE'){
          item.bykey=item.token0count
        }else {
          item.bykey=item.token1count
        }
      }
    },
  },
  created() {
    this.initData()
    // this.actionRequest();
  },
  mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>

.trans-icon-img {
  width: 26px;
  height: 29px;
  background: url("../../images/table/trans-black.png")no-repeat;
  background-size: 100% auto;
}

.tableBlock:hover {
  .trans-icon{
    background: #3772ff;
  }
  .trans-icon-img {
    background: url("../../images/table/trans-white.png")no-repeat;
    background-size: 100% auto;
  }
}

.trans-detail-text {
  opacity: 0.8 !important;
  line-height: 25px;
  span {
    cursor: pointer;
  }
}


</style>
